import * as I from 'iconsax-react';
import { IconProps } from 'iconsax-react';
import { forwardRef } from 'react';

export type IconNames = keyof typeof I;

interface IProps extends IconProps {
  name: IconNames;
}

const Icon = forwardRef<SVGSVGElement, IProps>(({ name, ...props }, ref) => {
  const TheIcon = I[name];
  return <TheIcon ref={ref} {...props} />;
});

Icon.displayName = 'Icon';

export default Icon;
